<div class="drop-down-list">
  <ng-container *ngFor="let item of items" >
    <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
  </ng-container>
</div>
